import { Box, Divider, Stack, Typography } from "@mui/material"
import {
  FilterSearchAndSelect,
  FullWidthContent,
  FullWidthHeader,
  MainContainer,
  PaperContent,
  type ReferentialValue,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { useNavigate } from "react-router-dom"
import { MarketingOperationLogo } from ".."

import { MarketingOperationsList } from "../../MarketingOperationsList"
import { adhMarketingOPApiRoleConf } from "../conf"
import { type ApiListAdhMarketingOperation, OperationSection } from "../model"
import { marketingOpColumns } from "./columns"

export const AdhMarketingOPList = ({ adherentId }: { adherentId?: string }) => {
  const navigate = useNavigate()
  const { endpoint, queryKey, readEndpoint } = useRoleConf(
    adhMarketingOPApiRoleConf(adherentId),
  )

  return (
    <MainContainer>
      <FullWidthContent>
        <FullWidthHeader title="OP Pharm-UPP" linkLabel="Opérations" linkTo="../" />

        <PaperContent>
          {/* LOGO + TITLE */}
          <Box display="flex" alignItems="center" gap={4} px={4} pt={4}>
            <MarketingOperationLogo />
            {/* <Logo width="96px" /> */}
            <Stack spacing={1}>
              <Typography
                fontSize={({ typography }) => typography.pxToRem(21)}
                fontWeight={500}
                color="primary.dark1"
                maxWidth="673px"
              >
                Développez votre attractivité commerciale et communiquez sur votre
                accompagnement pharmaceutique
              </Typography>

              <Divider color="success" sx={{ width: "110px", borderWidth: "1px" }} />
            </Stack>
          </Box>

          <MarketingOperationsList<ApiListAdhMarketingOperation>
            queryConfig={{
              queryKey,
              resourceEndpoint: endpoint,
              select: selectMarketingOpList,
            }}
            extraFilterElement={
              <FilterSearchAndSelect
                label="Statut"
                name="section"
                options={sectionOptions}
              />
            }
            columns={[
              { renderDefinition: marketingOpColumns.type, width: "14%" },
              { renderDefinition: marketingOpColumns.divider, width: "2%" },
              { renderDefinition: marketingOpColumns.operation, width: "27%" },
              { renderDefinition: marketingOpColumns.points, width: "15%" },
              { renderDefinition: marketingOpColumns.participation, width: "15%" },
              { renderDefinition: marketingOpColumns.justification, width: "15%" },
              { renderDefinition: marketingOpColumns.status, width: "12%" },
            ]}
            onRowClick={(row) => navigate(`./${row.id}`)}
            rowClickCondition={() => !!readEndpoint}
          />
        </PaperContent>
      </FullWidthContent>
    </MainContainer>
  )
}

const selectMarketingOpList = (operations: ApiListAdhMarketingOperation[]) =>
  operations.map((operation) => ({
    ...operation,
    validityStartDate: new Date(operation.validityStartDate).toLocaleDateString(),
    validityEndDate: new Date(operation.validityEndDate).toLocaleDateString(),
  }))

const sectionOptions: ReferentialValue<OperationSection>[] = [
  { label: "Auxquelles s'inscrire", value: OperationSection.REGISTRABLE },
  { label: "Inscrites", value: OperationSection.REGISTERED },
  { label: "À justifier", value: OperationSection.REQUIRES_PROOF },
  { label: "Validées", value: OperationSection.VALIDATED },
  { label: "Périmées", value: OperationSection.OUTDATED },
]
